import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from './EmptyState';

const EmptyStateArchive = () => {
  const { t } = useTranslation('components');

  return (
    <EmptyState
      kind="slate"
      title={t('AddressBook.EmptyStateArchive.title')}
      boxLabels={t('AddressBook.EmptyStateArchive.box_labels', { returnObjects: true })}
    >
      <div className="mx-4">{t('AddressBook.EmptyStateArchive.info', { allowHtml: true })}</div>
    </EmptyState>
  );
};

export default EmptyStateArchive;
